import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingOperations, OrderingSelectors } from 'polygon-ordering';

import debug from '../utils/debug';
import history from '../history';

import { setCurrentModal } from './setCurrentModal';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import type { RootState } from 'store';
import getConfig from '../selectors/getConfig';
import { MENU_SCREEN_ROUTE, PICK_BRAND_SCREEN_ROUTE } from '../hooks/useRoutes';

const { updateKeyOrderProperty } = OrderingOperations;
const { getLocationBrandsWithMenuRepresentation } = OrderingSelectors;

export const confirmLocationEstimate = createAsyncThunk(
  'confirmLocationEstimate',
  async (
    data: {
      locationId: string;
      isASAP?: boolean;
    },
    { dispatch, getState, rejectWithValue },
  ) => {
    const { locationId, isASAP } = data;
    debug('applying buffered delivery estimate');

    try {
      await dispatch(
        updateKeyOrderProperty({
          locationId,
          confirmLocationDeliveryEstimate: true,
          isASAP,
        }),
      );
      const modalParams = (getState() as RootState).modalParams;

      const representedBrands = getLocationBrandsWithMenuRepresentation(getState() as RootState);

      const multipleBrands = representedBrands.length > 1;

      const deviceTypeMobile = getDeviceTypeMobile(getState() as RootState);
      const enableBrandSelection = getConfig(getState() as RootState).enableBrandSelection;
      const showBrandPicker = deviceTypeMobile && enableBrandSelection && multipleBrands;

      if (modalParams?.allowRedirect !== false) {
        history.replace(showBrandPicker ? PICK_BRAND_SCREEN_ROUTE : MENU_SCREEN_ROUTE);
      }

      dispatch(setCurrentModal(null));
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
